module.exports = __webpack_public_path__ + "static/img/imagem-guias-manuais.5e7476d4.png";